module.exports = __webpack_public_path__ + "static/fcra-2016-17-q4-6f95c59fa1626dd1d31fb2808d2d35da.pdf";